<template>
  <div class="product-box clearfix">
    <div class="product-flag">
      <!-- <img v-if="info.tagsList != undefined && info.tagsList.includes('推荐')" src="../../../assets/images/product/icon-product-good@2x.png"/> -->
    </div>
    <div class="product-content">
      <div class="item left">
        <div class="left-img">
          <img :src="info.defaultimage" :alt="info.productname" />
        </div>
      </div>
      <div class="item right" style="height: 100%;">
        <div class="productName">
          {{ info.skuname }}
        </div>
        <div class="productCode">商品编号：{{ info.skucode }}</div>
        <div class="product-tag">
          <div
            class="product-tag-1"
            v-show="info.productevaluate > 0 && info.productevaluate != null"
          >
            产品质量评价
          </div>
          <div class="product-tag-2" v-if="info.ebillsign == 1">易权通</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
    itemNum: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      isEbill: false,
      isAuth: true,
      userInfo: {},
      dataEase: {},
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.userInfo;
    },
    mall_dataE() {
      return this.$store.state.dataE;
      // return this.$cookies.get("isLogin")
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler: function(newval) {
        this.userInfo = newval;
      },
    },
    mall_dataE: {
      immediate: true,
      handler: function(newval, oldVal) {
        if (newval) {
          this.dataEase = newval[newval.length - 1];
        }
      },
    },
  },
  created() {
    // this.judgeIsEbill();
  },
  methods: {
    ...mapActions(['clickProductEvent']), //
    goToDetail(item) {
      window.open(
        '//' +
          window.location.host +
          '/products/productDetail?productId=' +
          item.skuid +
          '&supplierId=' +
          item.suppliercompanyid
      );
      this.clickProductEvent({ ...item, comeSource: 1, itemNum: this.itemNum });
    },
    async judgeIsEbill() {
      let params = {
        companyId: this.info.suppliercompanyid,
      };
      let res = await this.$request.isEbill(params);
      this.isEbill = res.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.product-box {
  // background: #ffffff;
  .product-flag {
    position: absolute;
    z-index: 99;
    margin-left: 6px;
    img {
      width: 20px;
      height: 24px;
    }
  }
  .product-content {
    display: flex;
    justify-content: flex-start;
    .item {
      /* display: table-cell;
      vertical-align: middle; */
      float: left;
      img {
        position: relative;
        /*border: 1px solid #d9d9d9;*/

        width: 86px;
        height: 86px;

        text-align: center;
        line-height: 95px;
      }
      .left-img {
        position: relative;
        border: 1px solid #d9d9d9;

        width: 88px;
        height: 88px;
        text-align: center;
        line-height: 95px;
        img[lazy='error'] {
          width: 41px !important;
          height: 28px !important;
        }
        img[lazy='loading'] {
          width: 41px !important;
          height: 28px !important;
        }
      }
    }
    .left {
      position: relative;
      .invalid-sign {
        position: absolute;
        width: 58px;
        height: 58px;
        line-height: 58px;
        text-align: center;
        background: #000000;
        border-radius: 50%;
        opacity: 0.4;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        top: 50%;
        left: 50%;
        margin-left: -29px;
        margin-top: -29px;
      }
    }
    .right {
      padding-left: 10px;
      .productName {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 15px;

        color: #333333;
      }
      .productCode {
        margin-top: 10px;
        margin-bottom: 5px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        text-align: left;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 12px;

        color: #666666;
      }
      .product-tag {
        display: flex;
        flex-direction: row;
        .product-tag-1 {
          min-width: 80px;
          height: 20px;
          background: #ed9d17;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          padding: 2px 4px;
        }
        .product-tag-2 {
          width: 48px;
          height: 20px;
          background: #06ab73;
          border-radius: 4px;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          color: #ffffff;
        }
      }

      .reason-icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #bdc3df;
        line-height: 14px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
}
</style>
